import { useMemo } from "react";
import { Tabs, TabsProps, theme } from "antd";
import { EntityProperties } from "./EntityProperties";

/**
 * Ignores any incoming tabs that have the labels:
 * 1. Data
 * 2. Properties
 *
 * Automatically adds two properties panels:
 * 1. at the beginning, use `propertiesSkipList` to control
 * 2. at the end, with noisy system stuff
 */

export const EntityTabs = (props: {
  entity: any;
  tabs?: TabsProps["items"];
  propertiesSkipList?: string[];
}) => {
  const items = useMemo(() => {
    const autoProperties = {
      key: "auto-entity-properties",
      id: "auto-entity-properties",
      label: "Properties",
      children: (
        <EntityProperties
          skipKeys={props.propertiesSkipList}
          entity={props.entity}
        />
      ),
    };
    const systemProperties = {
      key: "auto-system-properties",
      id: "auto-system-properties",
      label: "System Info",
      children: <EntityProperties systemInfo entity={props.entity} />,
    };

    const overview = props.tabs?.find((t) => t.label == "Overview");
    const others =
      props.tabs?.filter((t) => t.label !== "Overview" && t.label !== "Data") ||
      [];

    return [overview!, autoProperties, ...others, systemProperties].filter(
      (t) => t !== undefined
    );
  }, [props.tabs, props.entity, props.propertiesSkipList]);

  const { token } = theme.useToken();
  return (
    <div
      style={{
        backgroundColor: token.colorBgContainer,
        borderRadius: 16,
        padding: "0 8px",
        height: "100%",
      }}
    >
      <Tabs
        defaultActiveKey="overview"
        size="small"
        items={items}
        style={{ height: "100%" }}
        destroyInactiveTabPane={true}
        renderTabBar={(props, TabBar) => <TabBar {...props} />}
      />
    </div>
  );
};
